import styled from 'styled-components';
import { FC, ReactNode } from 'react';

type SwarmFormats = {
	text: ReactNode;
	type: 'Title' | 'SubTitle' | 'SmallTitle' | 'TextName' | 'Paragraph' | 'SmallText';
	strong?: 'strong';
	textColor?:
		| 'text-swarm-yellow'
		| 'text-swarm-orange'
		| 'text-swarm-light-blue'
		| 'text-swarm-dark-pastel-blue'
		| 'text-swarm-blue'
		| 'text-swarm-purple'
		| 'text-swarm-pink'
		| 'text-swarm-super-light-gray'
		| 'text-swarm-less-light-gray'
		| 'text-swarm-gray'
		| 'text-swarm-dark-gray'
		| 'text-swarm-light-gray'
		| 'text-swarm-brown'
		| 'text-swarm-green'
		| 'text-swarm-disabled-green'
		| 'text-swarm-red'
		| 'text-athens-gray'
		| 'text-swarm-thin-gra'
		| 'text-intl-klein-blue'
		| 'text-dove-gray'
		| 'text-tree-poppy'
		| 'text-my-sin'
		| 'text-polo-blue'
		| 'text-tropical-blue'
		| 'text-old-lace'
		| 'text-dusty-gray'
		| 'text-tacao'
		| 'text-cornflower-blue'
		| 'text-swarm-light-purple';
	className?: string;
	style?: any;
};

const fontSize = {
	Title: '30px',
	SubTitle: '24px',
	SmallTitle: '20px',
	TextName: '16px',
	Paragraph: '14px',
	SmallText: '12px'
};

const SwarmStyle = styled.p<{ textTag: string; strong?: string }>`
	font-size: ${({ textTag }) => textTag};
	font-weight: ${(props) => (props.strong ? 'bold' : 'normal')};
`;

export const SwarmText: FC<SwarmFormats> = ({
	text,
	type,
	className,
	strong = '',
	textColor = 'text-swarm-blue',
	style
}) => (
	<SwarmStyle textTag={fontSize[type]} strong={strong} className={`${textColor} ${className || ''}`} style={style}>
		{text}
	</SwarmStyle>
);

export const NavBarTitle = styled.h1`
	color: #013e9e;
	font-size: 30px;
	font-weight: bold;
	font-family: QuickSand;
`;
export const TitleSwarm = styled.h1`
	color: #fd8b26;
	font-size: 30px;
	font-weight: bold;
	font-family: QuickSand;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
`;

export const TitleSwarmPurple = styled.h1`
	color: #bd88c6;
	font-size: 30px;
	font-weight: bold;
	font-family: QuickSand;
`;

export const SectionTitleSwarm = styled.h1`
	color: #013e9e;
	font-size: 24px;
	font-weight: bold;
	font-family: QuickSand;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
`;

export const InterTitleSwarm = styled.h1`
	color: #fd8b26;
	font-size: 20px;
	font-weight: bold;
	font-family: QuickSand;
`;

export const InterTitleSwarmLabel = styled.label`
	color: #fd8b26;
	font-size: 20px;
	font-weight: bold;
	font-family: QuickSand;
`;

export const SubTitleSwarm = styled.h2`
	color: #013e9e;
	font-size: 16px;
	font-weight: bold;
	font-family: QuickSand;
`;

export const SubTitleSwarmLabel = styled.label`
	color: #013e9e;
	font-size: 16px;
	font-weight: bold;
	font-family: QuickSand;
`;

export const TitleBlockSwarm = styled.h2`
	color: #555353;
	font-size: 16px;
	font-family: Poppins;
	font-weight: 500;
`;

export const BlockTextSwarm = styled.p`
	color: #555353;
	font-size: 14px;
	font-family: Poppins;
`;

export const UrlTextSwarm = styled.a<{ color?: string }>`
	color: ${(color) => (color ? '#013E9E' : '#FD8B26')};
	font-size: 14px;
	font-family: Poppins;
`;

export const ExtraTextSwarm = styled.p`
	color: #555353;
	font-size: 14px;
	font-family: Poppins;
	font-weight: 500;
`;

export const GuideTextSwarm = styled.p`
	color: #35ad71;
	font-size: 14px;
	font-family: Poppins;
`;

export const SmallSubTitleSwarm = styled.h3`
	color: #013e9e;
	font-size: 12px;
	font-weight: bold;
	font-family: QuickSand;
`;

export const HelpTextSwarm = styled.p`
	color: #edaf93;
	font-size: 12px;
	font-family: Poppins;
`;

// Estilos de estudiante:

export const TitleSwarmStudent = styled.h1`
	color: #013e9e;
	font-size: 30px;
	font-weight: bold;
	font-family: QuickSand;
`;

export const SubtitleSwarmStudent = styled.h2`
	color: #013e9e;
	font-size: 16px;
	font-weight: bold;
	font-family: QuickSand;
`;

export const ExtraTextSwarmStudent = styled.p`
	color: #555353;
	font-size: 14px;
	font-family: Poppins;
	font-weight: 500;
`;

export const ExtraTextSwarmSpan = styled.span`
	color: #013e9e;
	font-size: 14px;
	font-family: Poppins;
	font-weight: 700;
`;

export const TitleBlockSwarmStudent = styled.h2`
	color: #fd8b26;
	font-size: 16px;
	font-family: QuickSand;
	font-weight: bold;
`;

export const TitleBlockSwarmStudentRubrica = styled.h2`
	color: #bd88c6;
	font-size: 16px;
	font-family: QuickSand;
	font-weight: bold;
`;

export const AlertNotificationText = styled.p`
	font-size: 14px;
	font: Poppins;
	color: #ff5055;
	opacity: 1;
	font-weight: 700;
`;

export const BigAlertNotificationText = styled.p`
	font-size: 24px;
	font: Poppins;
	color: #ff5055;
	opacity: 1;
	font-weight: 700;
`;

export const MediumAlertNotificationText = styled.p`
	font-size: 18px;
	font: Poppins;
	color: #ff5055;
	opacity: 1;
	font-weight: 700;
`;

export const GuardarText = styled.p`
	color: #35ad71;
	font-size: 13px;
`;

export const TitleSwarmPoppins = styled.p`
	font-size: 36px;
	letter-spacing: 0px;
	color: #fd8b26;
	opacity: 1;
	font-family: Poppins;
`;

export const SubtitleSwarmPoppins = styled.p`
	font-size: 20px;
	letter-spacing: 0px;
	color: #fd8b26;
	opacity: 1;
	font-family: Poppins;
`;
